import './index.css'
import {getSearchParams} from 'lib/url'

const script = document.createElement('script')

script.src = `${process.env.CDN_ORIGIN}${process.env.CDN_PREFIX}/sdk.js`
document.head.appendChild(script)

const {
  widget,
  'max-width': maxWidth,
  ...widgetParams
} = getSearchParams(window.location.href)

const container = window.app

window.app.style.maxWidth = maxWidth

window.RamblerQuiz = window.RamblerQuiz || []
window.RamblerQuiz.push(() => {
  window.RamblerQuiz.buildWidget(widget, container, widgetParams).then(
    (widget) => {
      widget.on('changeSize', (size) => {
        window.parent.postMessage(
          {
            sentinel: 'amp',
            type: 'embed-size',
            height: size.height
          },
          '*'
        )
      })
    }
  )
})
